<div class="container-home">
    <section class="container-blue">
        <div class="container d-flex">
            <div>
                <h2>
                    Indicação de condutor
                    <svg-icon class="icon-condutor" src="../../../assets/icon/condutor.svg"></svg-icon>
                </h2>
                <hr size="10" width="20%" align="left" class="linha-horizontal">
                <p>No painel você encontra os lotes com documentos que precisam ser avaliados antes de virarem indicação de condutor.</p>
                <p>Ao terminar a avaliação de um lote, as indicações serão efetivadas no sistema de processamento.</p>
            </div>
        </div>
    </section>
    <section class="modals">
        <app-modal-lotes  [lotesIndicacao]="lotes" (loteIdSelecionado)="receberLoteSelecionado($event)" (recarregarLotes)="recarregarLotes($event)"></app-modal-lotes>
    </section>
</div>